import React from 'react';

/**
 * Fundo cinematográfico das telas de login: foto com zoom lento (Ken Burns)
 * + 3 camadas de neblina em CSS puro (gradientes + blur + transform), sem
 * vídeo/canvas. Cada camada roda num loop sem costura (translateX de um
 * elemento 2x mais largo que o viewport, com o padrão repetido a cada 50%).
 * Puramente decorativo — nunca deve interceptar cliques nem ficar acima do
 * formulário.
 */
export default function LoginBackdrop({ image }) {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div
        className="login-scene-image absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="login-mist-layer login-mist-1" />
      <div className="login-mist-layer login-mist-2" />
      <div className="login-mist-layer login-mist-3" />
      <div className="login-vignette absolute inset-0" />
    </div>
  );
}
